<div class="d-flex flex-column justify-content-center">
  <h3 mat-dialog-title>{{title}}</h3>
  <div mat-dialog-content class="w-100" justify-content-center>
    {{text}}
  </div>
  <div mat-dialog-actions class="w-100 justify-content-center">
    <button mat-button (click)="dialogRef.close()">{{close}}</button>
  </div>
</div>

